import { okhttp } from "./okhttp/client.mjs";
export const kotlin = {
    info: {
        key: 'kotlin',
        title: 'Kotlin',
        extname: '.kt',
        default: 'okhttp',
    },
    clientsById: {
        okhttp,
    },
};
